<div class="bg-white border-ace-grey-400 border-b text-sm" [class.hidden]="!showDefaultNav">
  <header class="font-body container mx-auto flex align-top py-4 sm:px-4 relative">
    <skip-nav></skip-nav>
    <a href="/" class="mr-0 sm:mr-8 lg:mr-0 xl:mr-8 min-h-[44px] min-w-[171px]" aria-label="Home Navigation Link">
      <img
        class="ace__nav-logo hidden lg:flex max-h-10"
        [src]="aaLogoBlue"
        width="140"
        height="50"
        alt="Aceable Agent Logo (Header)"
        loading="lazy"
        />

      <img
        class="flex lg:hidden max-h-10"
        [src]="aaLogoBlue"
        width="140"
        height="36"
        alt="Aceable Agent Logo (Header)"
        loading="lazy"
        />
    </a>
    <nav class="ace__nav flex grow align-middle">
      @for (navLink of headerData; track navLink) {
        <ace-header-navlink [data]="navLink" class="items-center hidden lg:flex">
        </ace-header-navlink>
      }
    </nav>
    <nav class="ace__nav hidden lg:flex lg:align-middle justify-end" data-test="accountNav">
      @for (navLink of accountData; track navLink) {
        <ace-header-navlink [data]="navLink" class="items-center hidden lg:flex">
        </ace-header-navlink>
      }
    </nav>
    @if (showAdaChatbot) {
      <button (click)="openAdaChat()" class="w-[30px] h-[30px] min-w-[30px] min-h-[30px] rounded-full flex items-center justify-center self-center bg-ace-pink-600 hover:bg-ace-pink-700 cursor-pointer" aria-label="Open AI Virtual Assistant chat" title="AI Virtual Assistant" type="button">
        <img src="https://xgrit-ecom.imgix.net/v3_images/ada-chatbot.svg?auto=format,compress" alt="Open AI Virtual Assistant chat" class="w-[15px] h-[15px]">
      </button>
    }
    <button (click)="activateMobileMenu = !activateMobileMenu" class="text-vis-regular text-xs lg:hidden items-center ml-3"
      aria-label="Open navigation menu"
      >
      <fa-icon class="mr-4 text-md fa-1x" [icon]="faHamburger" aria-label="Open navigation menu"></fa-icon>
    </button>
  </header>
</div>
@if (activateMobileMenu) {
  <div class="ace__nav-mobile_legacy flex flex-col justify-items-start content-start fixed top-0 left-0 flex w-full h-full z-[1022]">
    <div class="ace__nav-mobile_menu_legacy h-full overflow-y-auto bg-white relative">
      <div class="p-5 text-md">
        <img
          class="flex lg:hidden max-h-10 text-ace-teal-700"
          [src]="aaLogoBlue"
          width="140"
          height="36"
          alt="Aceable Agent Logo (Header)"
          loading="lazy"
          />
        <fa-icon
          class="text fa-1x absolute right-7 cursor-pointer top-5"
          (click)="activateMobileMenu = !activateMobileMenu"
          [icon]="faTimes"
          aria-label="Close navigation menu"
        ></fa-icon>
      </div>
      @for (vertLink of mobileHeaderData; track vertLink) {
        <collapse-link [link]="vertLink"></collapse-link>
      }
    </div>
  </div>
}
